import { useTranslation } from "react-i18next";

import { UltraSonicMeasurement } from "../../shared/interfaces/Result";
import { MeasurementType } from "../../shared/enums/Result";

import { Card } from "../../shared/Card";
import { FormRow } from "../../shared/FormLayout/FormRow";
import { CopyToClipboard } from "../../shared/CopyToClipboard";
import { useMemo } from "react";

interface UltraSonicMeasurementCardProps {
  measurement: UltraSonicMeasurement;
}

export function UltraSonicMeasurementCard(props: UltraSonicMeasurementCardProps) {
  const { t } = useTranslation();

  const data = useMemo(
    () => [
      {
        label: t("measurements.MeasureDBUV"),
        value: props.measurement.MeasureDBUV ?? "",
      },
      {
        label: t("measurements.UltraSonicClassification"),
        value:
          (props.measurement.UltraSonicClassification
            ? t(`UltrasonicClassification.${props.measurement.UltraSonicClassification}`)
            : "") ?? "",
      },
      {
        label: t("measurements.UltraSonicAccessory"),
        value:
          (props.measurement.UltraSonicAccessory
            ? t(`UltrasonicAccessory.${props.measurement.UltraSonicAccessory}`)
            : "") ?? "",
      },
      {
        label: t("measurements.UltraSonicClassificationCertainty"),
        value: props.measurement.UltraSonicClassificationCertainty ?? "",
      },
      {
        label: t("measurements.PhaseReferenceLock"),
        value: props.measurement.PhaseReferenceLock ? t("common.true") : t("common.false"),
      },
      {
        label: t("measurements.PhaseReferenceType"),
        value: props.measurement.PhaseReferenceType
          ? t(`PhaseReferenceType.${props.measurement.PhaseReferenceType}`)
          : ("" ?? ""),
      },
    ],
    [t, props.measurement],
  );

  function constructClipboardText() {
    return data.map((d) => `${d.label}, ${d.value}`).join("\n");
  }

  return (
    <Card
      title={t("results.measurementType", {
        measurementType: `$t(MeasurementTypes.${MeasurementType.Ultra} )`,
      })}
      className="mb-3"
      action={<CopyToClipboard textToCopy={constructClipboardText()} />}
    >
      {data.map((d) => (
        <FormRow label={d.label} value={d.value} />
      ))}
    </Card>
  );
}
